'use client';

import { Button } from '@fastfive-dev/fastfive-design-system/components';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { ErrorPageSection } from './ErrorPageSection';

/**
 * 두 버튼 모두 w-192 고정 — 시안은 192 / 191(hug) 이지만, 디자인 시스템 Button 은
 * Figma 컴포넌트에 있는 라벨 안쪽 여백(px-4)이 없어 hug 로 두면 182 로 좁아진다.
 */
const ACTION_WIDTH = 'w-192';

/** 글로벌 404 본문. */
export function NotFoundSection() {
  const router = useRouter();

  return (
    <ErrorPageSection
      title="페이지를 찾을 수 없습니다"
      description={
        <>
          주소가 잘못 입력되었거나,
          <br />
          변경 또는 삭제된 페이지입니다.
        </>
      }
      actions={
        <>
          <Button asChild size="large" className={ACTION_WIDTH}>
            <Link href="/">홈으로</Link>
          </Button>
          {/* stroke 는 테두리만 덧입힐 뿐 배경을 지우지 않는다. 아웃라인 버튼은
              color="white"(흰 배경) 와 함께 써야 한다. */}
          <Button
            size="large"
            color="white"
            stroke
            className={ACTION_WIDTH}
            onClick={() => router.back()}
          >
            이전 페이지로 이동
          </Button>
        </>
      }
    />
  );
}
